import iFrameResize from 'iframe-resizer/js/iframeResizer.min';

export default {
    data: function () {
        return {
            isVisible: true
        };
    },
    methods: {
        iFrameLoaded() {
            const self = this;
            iFrameResize({
                enablePublicMethods: true,
                checkOrigin: [
                    'https://drug-reserve.wub-api.de',
                    'https://test.drug-reserve.wub-api.de'
                // only for develop
                //,'http://www.pupa1.de:8080',
                //'http://localhost:9090'
                ],
                messageCallback: function(res){
                    if (res && res.message === 'success') {
                        self.isVisible = false;
                    }
                }
            }, '#preorderFrame' );
        }
    }
};